/** Minimal country shape the postal code lookup needs — `ICountry[]` satisfies it. */
export interface IPostalCodeCountry {
  id: string;
  code: string;
  name: string;
}

let countries: IPostalCodeCountry[] = [];

/**
 * The countries list, kept outside the store for the postal code validator.
 * Reference data that never changes within a session, hence a plain module-level copy rather than
 * plumbing the list through every validation call site.
 */
export const setPostalCodeCountries = (list: IPostalCodeCountry[] = []) => {
  countries = list;
};

export const getPostalCodeCountries = (): IPostalCodeCountry[] => countries;

/** Looks a country up by the id the forms store (`'germany'`, `'netherland'`, ...). */
export const findPostalCodeCountry = (countryId?: string | null) =>
  countryId ? countries.find(({ id }) => id === countryId) : undefined;
